export const Ease: Record<'InOut' | 'Out', [number, number, number, number]> = {
  InOut: [0.86, 0, 0.07, 1],
  Out: [0.19, 1, 0.22, 1],
};
